
import { useAppSelector } from "../store/hooks";
import axiosInstance from "../api/axiosInstance";
import { useAppDispatch } from "../store/hooks";
import { switchRole } from "../features/auth/authSlice";
import { toast } from "react-toastify";


export default function SwitchRole() {
    const dispatch = useAppDispatch();
    const { user, defaultRole } = useAppSelector((s) => s.auth);
    const roles = user?.roles || [];

    const handleSwitchRole = (role: string) => {
        axiosInstance.post(`/admin/switch-role?targetRole=${role}`)
            .then((res) => {
                console.log("response", res.data);
                dispatch(switchRole(res.data));
                toast.success("Switched to " + role);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    return (
        <>
            {defaultRole == "admin" && roles.includes("doctor") ? (
                <button className="bg-indigo-600 text-white px-4 py-2 rounded-md mt-5" onClick={() => handleSwitchRole("doctor")}>Switch to Doctor</button>
            ) : null}
            {defaultRole == "doctor" && roles.includes("admin") ? (
                <button className="bg-indigo-600 text-white px-4 py-2 rounded-md mt-5" onClick={() => handleSwitchRole("admin")}>Switch to Admin</button>
            ) : null}
        </>
    );
}